import React, { memo } from "react";

const RequestsMenuIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
    >
      <path
        d="M0 10.9665V2.07758C0 1.58869 0.174074 1.17018 0.522222 0.822027C0.87037 0.473879 1.28889 0.299805 1.77778 0.299805H14.2222C14.7111 0.299805 15.1296 0.473879 15.4778 0.822027C15.8259 1.17018 16 1.58869 16 2.07758V10.9665C16 11.4554 15.8259 11.8739 15.4778 12.222C15.1296 12.5702 14.7111 12.7442 14.2222 12.7442H1.77778C1.28889 12.7442 0.87037 12.5702 0.522222 12.222C0.174074 11.8739 0 11.4554 0 10.9665ZM1.77778 3.85536H3.55556V2.07758H1.77778V3.85536ZM5.33333 3.85536H14.2222V2.07758H5.33333V3.85536ZM5.33333 7.41092H14.2222V5.63314H5.33333V7.41092ZM5.33333 10.9665H14.2222V9.18869H5.33333V10.9665ZM1.77778 10.9665H3.55556V9.18869H1.77778V10.9665ZM1.77778 7.41092H3.55556V5.63314H1.77778V7.41092Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { RequestsMenuIcon };
